import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BugOutlined } from "@ant-design/icons";
import { Result } from "antd";
import { Helmet } from "react-helmet";
import { useTranslation } from "../../others/i18n.js";
import { centered } from "../../styles/template.js";
const RouteError404 = ()=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                children: /*#__PURE__*/ _jsx("title", {
                    children: t("Page not found")
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                style: centered,
                children: /*#__PURE__*/ _jsx(Result, {
                    icon: /*#__PURE__*/ _jsx(BugOutlined, {}),
                    title: t("Page not found")
                })
            })
        ]
    });
};
export { RouteError404 };
